<template>
	<v-dialog v-model="modal" width="700" >
		<v-card>
			<v-card-title class="headline grey lighten-2"> {{ formTitle }} </v-card-title>

			<v-divider></v-divider>

			<div class="container px-8 edit-form" v-if="item">
				<div class="row">
					<div class="col-sm-12">
						<v-text-field v-model="item.title" label="Item Title" :error-messages="titleErrors" @input="$v.item.title.$touch()" @blur="$v.item.title.$touch()"></v-text-field>
					</div>
				</div>

				<div class="row">
					<div class="col-sm-12">
						<v-text-field v-model="item.slug" label="Item Slug" :error-messages="slugErrors" @input="$v.item.slug.$touch()" @blur="$v.item.slug.$touch()"></v-text-field>
					</div>
				</div>

				<div class="row">
					<div class="col-sm-12">
						<textarea v-model="item.description" placeholder="Item Description"></textarea>
					</div>
				</div>
			</div>

			<div class="container px-8 edit-form" v-if="unit">
				<!-- <div class="row">
					<div class="col-sm-12 mb-4">
						<div v-if="!newImage">
							<v-img :src="unit.preview" height="200px"></v-img>

							<v-row align="center" justify="center" class="py-3">
								<v-btn color="primary" @click="newImage = true">Upload New</v-btn>
							</v-row>
						</div>

						<div v-if="newImage && !image">
							<div class="image-uploader">
								<p class="item-subtitle">Click to upload an image</p>
								<input type="file" accept="image/jpeg" @change="setImage">
							</div>

							<v-row align="center" justify="center" class="py-3">
								<v-btn color="primary" @click="newImage = ''">Cancel</v-btn>
							</v-row>
						</div>

						<div v-if="newImage && image">
							<cropper class="cropper" :src="image" @change="cropImage"/>
							<v-row align="center" justify="center" class="py-3">
								<v-btn color="primary" @click="image = ''">Cancel</v-btn>
							</v-row>
						</div>
					</div>
				</div> -->

				<div class="row">
					<div class="col-sm-12">
						<v-text-field v-model="unit.title" label="Unit Title" :error-messages="unitTitleErrors" @input="$v.unit.title.$touch()" @blur="$v.unit.title.$touch()"></v-text-field>
					</div>
				</div>

				<div class="row">
					<div class="col-sm-6">
						<v-text-field v-model="unit.price" label="Unit Price" :error-messages="priceErrors" @input="$v.unit.price.$touch()" @blur="$v.unit.price.$touch()"></v-text-field>
					</div>

					<div class="col-sm-6">
						<v-text-field v-model="unit.characteristics.volume" label="Unit Volume"></v-text-field>
					</div>
				</div>
			</div>

			<v-card-actions class="headline grey lighten-2">
				<v-spacer></v-spacer>
				<v-btn color="blue darken-1" text @click="close()">Cancel</v-btn>
				<v-btn color="primary" @click="submit()"> Submit </v-btn>
				<v-spacer></v-spacer>
			</v-card-actions>
		</v-card>
    </v-dialog>
</template>

<script>
	import { validationMixin } from 'vuelidate';
	import { required } from 'vuelidate/lib/validators';
	import { Cropper } from 'vue-advanced-cropper';
	import 'vue-advanced-cropper/dist/style.css';

    import './style.scss';

	export default {
		name: 'ItemForm',
		components: { Cropper },
		props: ['modal', 'formTitle', 'close', 'item', 'unit', 'uid', 'action'],
		mixins: [validationMixin],
		validations: {
			item: {
				title: { required },
				slug: { required }
			},

			unit: {
				title: { required },
				price: { required }
			}
		},

		data: () => {
            return {
				title: '',
				price: '',
				description: '',
				newImage: false,
				image: '',
				cropped: '',
				filename: ''
			}
        },
		
		computed: {
			titleErrors() {
				const errors = [];
				if (!this.$v.item.title.$dirty){
					return errors;
				}

				!this.$v.item.title.required && errors.push('Title is required');

				return errors;
			},

			slugErrors() {
				const errors = [];
				if (!this.$v.item.slug.$dirty){
					return errors;
				}

				!this.$v.item.slug.required && errors.push('Slug is required');

				return errors;
			},

			priceErrors() {
				const errors = [];
				if (!this.$v.unit.price.$dirty){
					return errors;
				}

				!this.$v.unit.price.required && errors.push('Unit Price is required');

				return errors;
			},

			unitTitleErrors() {
				const errors = [];
				if (!this.$v.unit.title.$dirty){
					return errors;
				}

				!this.$v.unit.title.required && errors.push('Unit Title is required');

				return errors;
			}
		},

		methods: {
			// setImage(e){
			// 	const file = e.target.files[0];
			// 	this.filename = file.name;

			// 	if (typeof FileReader === "function") {
			// 		const reader = new FileReader();

			// 		reader.onload = event => {
			// 			this.image = event.target.result;
			// 		};

			// 		reader.readAsDataURL(file);
			// 	}
			// },

			// cropImage(cropped) {
			// 	this.cropped = cropped.image.src;
			// },

			// dataURIToBlob(dataURI) {
			// 	const splitDataURI = dataURI.split(',')
			// 	const byteString = splitDataURI[0].indexOf('base64') >= 0 ? atob(splitDataURI[1]) : decodeURI(splitDataURI[1])
			// 	const mimeString = splitDataURI[0].split(':')[1].split(';')[0]

			// 	const ia = new Uint8Array(byteString.length)
			// 	for (let i = 0; i < byteString.length; i++)
			// 		ia[i] = byteString.charCodeAt(i)

			// 	return new Blob([ia], { type: mimeString })
			// },

			submit(){
				this.$v.$touch();

				let bodyFormData = new FormData(),
					id = '';
				
				if(this.item){
					if(this.titleErrors.length || this.slugErrors.length){
						return;
					}

					id = this.item.uid;
					bodyFormData.append('Item[title]', this.item.title);
					bodyFormData.append('Item[description]', this.item.description);
					bodyFormData.append('Item[slug]', this.item.slug);
				}
				
				if(this.unit){
					if(this.unitTitleErrors.length || this.priceErrors.length){
						return;
					}
					
					id = this.unit.sku_number;
					bodyFormData.append('Unit[price]', this.unit.price);
					bodyFormData.append('Unit[title]', this.unit.title);
					bodyFormData.append('Unit[characteristics][volume]', this.unit.characteristics.volume);

					if(this.cropped){
						let formatedImage = this.dataURIToBlob(this.cropped)
						bodyFormData.append('Unit[preview]', formatedImage, this.filename);
					}
				}

				this.$store.dispatch(this.action, { id: id, data: bodyFormData, uid: this.uid });
				this.close();
			}
		}
	}
</script>

<style scoped>
	.image-uploader{
		width: 100%;
		height: 300px;
		position: relative;
		display: flex;
		align-items: center;
		border: 1px solid #424242;
	}

	.image-uploader input{
		width: 100%;
		opacity: 0;
		position: absolute;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;		
	}

	.image-uploader p{
		width: 100%;
		text-align: center;
	}

	.cropper{
		width: 636px;
		height: 300px;
	}
</style>
